import { WrappedAppActions } from 'records/AppState';
import { getPageUrl } from 'services/pageService';
import { CalibrationMachineServices } from './calibrationMachine';

const createCalibrationMachineServices = ({
  createMappedSheetVersion,
}: Pick<
  WrappedAppActions,
  'createMappedSheetVersion'
>): CalibrationMachineServices => ({
  initializeContext: async (documentid, pageid) => {
    const url = await getPageUrl(documentid, pageid);
    return url;
  },
  saveCalibration: (imageCalibrationConfig, sheetVersion) => {
    createMappedSheetVersion(sheetVersion.pageid, imageCalibrationConfig);
  },
});

export default createCalibrationMachineServices;
